export default "__VITE_ASSET__CXIraZY9__"